import { Deserializable } from "./Deserializable";

export class Menu implements Deserializable {

  name?: string;
  baseUrl?: string;
  baseUrlTwo?: string;
  domaine?: string;
  domainJO?: string;
  subDomainJO?: string;
  route?: string;
  title?: string;
  version?: number;
  order?: number;
  dinamica?: boolean;
  dynamic?: boolean;
  add?: boolean;
  delete?: boolean;
  matchkey?: string;
  clase?: string;
  component?: string;
  visible?: string | boolean;
  service?: string;
  typePerson?: string;
  typeSearch?: string;
  sortDataField?: string;
  matchkeyInput?: string;
  periods?: boolean;
  periodsType?: string;
  periodsSection?: string;

  constructor() {
    // This is intentional
  }

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}

class ChangeDetails {
  fieldToChange?: string;
  newValue?: string;
}

class ValuesDetails {
  value?: string;
  text?: string;
}
